import styles from './App.module.css';
import { useWindowsDimension } from './hooks/useWindowsDimension';
import { IsMobileContext, IsSmallDesktopContext } from './components/context/context';
import { Header } from './components/sections/header/Header';
import { Outlet } from 'react-router-dom';
import {Bounce, ToastContainer} from 'react-toastify';
import { Footer } from './components/sections/footer/Footer';
import { ScrollToTop } from './components/utils/ScrollToTop';

function App() {
  const {isMobile, isSmallDesktop} = useWindowsDimension()

  return (
    <main className={styles.App}>
      <IsMobileContext.Provider value={isMobile}>
        <IsSmallDesktopContext.Provider value={isSmallDesktop}>
          <ScrollToTop />
          <ToastContainer 
            position="top-right"
            autoClose={2500}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick={true}
            rtl={false}
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
            theme="light"
            transition={Bounce}
          />
          <Header />
          <Outlet />
          <Footer />
        </IsSmallDesktopContext.Provider>
      </IsMobileContext.Provider>
    </main>
  );
}

export default App;
